export const TOGGLE_LANG = 'TOGGLE_LANG';
